"use client";

import Form from "next/form";
import type { FormEvent } from "react";
import styles from "./reader.module.css";

/** 送信元フォームを受け取り、親の検索パネルだけを閉じる。戻り値・例外なし。検索送信は妨げない。 */
function closeSearchPanel(event: FormEvent<HTMLFormElement>) {
	const panel = event.currentTarget.closest("details");
	if (panel) panel.open = false;
}

/** 検索語と入力IDからGET検索を描画する。遷移時も共通枠を維持し、JavaScriptなしでは通常フォームとして動作する。 */
export default function SearchForm({
	query = "",
	id = "article-search",
}: {
	query?: string;
	id?: string;
}) {
	return (
		<Form action="/search" className={styles.search} role="search" onSubmit={closeSearchPanel}>
			<label htmlFor={id} className="sr-only">
				記事・選手名を検索
			</label>
			<span aria-hidden="true">⌕</span>
			<input
				id={id}
				name="q"
				type="search"
				maxLength={80}
				defaultValue={query}
				placeholder="記事・選手名"
			/>
			<button type="submit">検索</button>
		</Form>
	);
}
